import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ItemAuctionService} from '../shared/item-auction.service';
import {ButtonRadioOption, DialogService} from '@rbaip/ui-component';
import {ItemAuctionInfo} from '../shared/item-auction-info.model';
import {unitTypeList} from '../shared/unit-type.constants';
import {Observable, of} from 'rxjs';

@Component({
  selector: 'lib-item-listing-sale-by-unit',
  templateUrl: './sale-by-unit.component.html',
  styleUrls: ['./sale-by-unit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaleByUnitComponent implements OnChanges {

  @Input() itemAuctionInfo: ItemAuctionInfo;
  @Input() writable: boolean;
  @Output() refreshAuctionInfoEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  yesNoRadioButtonOptions: ButtonRadioOption[] = [{display: 'No', value: 'No'}, {display: 'Yes', value: 'Yes'}];
  unitTypeOptions = unitTypeList;
  filteredUnitTypeOptions: Observable<any>;

  constructor(private itemAuctionService: ItemAuctionService,
              private dialogService: DialogService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.itemAuctionInfo && changes.itemAuctionInfo.currentValue) {
      this.itemAuctionInfo = this.itemAuctionInfo.clone();
      this.repopulateTheFullListOfDropdownOptions();
    }
  }

  toggleSaleByUnit(): void {
    if (this.itemAuctionInfo.saleByUnit === 'No') {
      this.itemAuctionInfo.quantity = null;
      this.itemAuctionInfo.unitType = null;
      this.saveSaleByUnitInfo();
    }
  }

  public saveSaleByUnitInfo() {
    if (this.itemAuctionInfo.isSaleByUnitInfoValid()) {
      this.focusItemQuantity();
      this.repopulateTheFullListOfDropdownOptions();
      this.itemAuctionService.saveSaleByUnitInfo(this.itemAuctionInfo)
        .subscribe(response => {
          if (!response) {
            this.dialogService.showMessage('Successfully saved Sale By Unit info!');
          } else {
            this.dialogService.showMessage(response.error.message);
          }
          this.refreshAuctionInfo();
        });
    }
  }

  private focusItemQuantity(): void {
    const itemQuantityElem: HTMLElement = document.getElementById('item-quantity');
    if (itemQuantityElem) {
      itemQuantityElem.focus();
    }
  }

  private repopulateTheFullListOfDropdownOptions(): void {
    this.filteredUnitTypeOptions = of(this.unitTypeOptions.slice());
  }

  private refreshAuctionInfo(): void {
    this.refreshAuctionInfoEvent.emit(true);
  }

  doFilterUnit() {
    const filteredUnitTypeOptions = this.itemAuctionInfo.unitType ? this.filterUnitTypeOptions(this.itemAuctionInfo.unitType) : this.unitTypeOptions.slice();
    this.filteredUnitTypeOptions = of(filteredUnitTypeOptions);
  }

  private filterUnitTypeOptions(unitType: string) {
    if (unitType !== '') {
      const filterValue = unitType.toLowerCase();
      return this.unitTypeOptions.filter(unitTypeOption => unitTypeOption.name.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  clearUnitTypeAutocompleteSearch() {
    this.itemAuctionInfo.unitType = null;
    this.doFilterUnit();
  }
}
